class CookieBanner extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      activeClass: 'is-active',
      closingClass: 'is-closing'
    };
    this.banner = this.querySelector('.cookie-banner');

    if (this.dataset.testMode === 'true') {
      this.init();

      this.querySelectorAll('.button').forEach(
        (button) => button.addEventListener('click', this.close.bind(this))
      );
    }
    else {
      this.loadPrivacyApi();
    }
  }

  connectedCallback() {
    if (window.Shopify && Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  disconnectedCallback() {
    clearTimeout(this.privacyRetry);
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    if (window.Shopify && Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  onSectionLoad(event) {
    filterShopifyEvent(event, this, this.open.bind(this));
  }
  onSectionSelect(event) {
    filterShopifyEvent(event, this, this.open.bind(this));
  }
  onSectionDeselect(event) {
    filterShopifyEvent(event, this, this.close.bind(this));
  }

  beforeInit() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

    if (!window.location.pathname.match(/^(\/[a-z]{2}(-[A-Z]{2})?)?\/cart$/) && !userCanBeTracked && userTrackingConsent === 'no_interaction') {
      this.init();

      this.querySelectorAll('.button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  }

  init() {
    if (window.Shopify && Shopify.designMode) {
      return;
    }

    clearTimeout(this.openTimer);
    this.openTimer = setTimeout(() => {
      if (this.isConnected) this.open();
    }, Math.max(0, parseInt(this.dataset.delay) || 0) * 1000);
  }

  open() {
    this.banner.classList.add(this.classes.activeClass);
  }

  close() {
    this.banner.classList.add(this.classes.closingClass);

    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      this.banner.classList.remove(this.classes.activeClass);
      this.banner.classList.remove(this.classes.closingClass);
    }, 500);
  }

  onButtonClick(event) {
    event.preventDefault();
    if (this.savingChoice) return;
    const button = event.currentTarget;
    if (!button || !['accept', 'decline'].includes(button.name)) return;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
      this.showChoiceError();
      this.loadPrivacyApi();
      return;
    }
    const accepted = button.name === 'accept';
    this.savingChoice = true;
    this.setAttribute('aria-busy', 'true');
    const finish = (result) => {
      this.savingChoice = false;
      this.removeAttribute('aria-busy');
      if (result && (result.error || result instanceof Error)) { this.showChoiceError(); return; }
      this.querySelector('.cookie__save-error')?.remove();
      this.close();
    };
    try {
      privacy.setTrackingConsent({ analytics: accepted, marketing: accepted, preferences: accepted }, finish);
    } catch (error) { finish({ error: true }); }
  }

  showChoiceError() {
    let error = this.querySelector('.cookie__save-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'cookie__save-error';
      error.setAttribute('role', 'alert');
      (this.querySelector('.cookie__content') || this.banner).appendChild(error);
    }
    error.textContent = "We couldn't save your privacy choice. Please try again.";
  }

  loadPrivacyApi() {
    if (this.privacyLoading || (this.privacyAttempts || 0) >= 3) return;
    this.privacyLoading = true;
    this.privacyAttempts = (this.privacyAttempts || 0) + 1;
    const finished = (error) => {
      this.privacyLoading = false;
      if (!error && window.Shopify && window.Shopify.customerPrivacy) {
        if (!this.privacyReady) { this.privacyReady = true; this.beforeInit(); }
        return;
      }
      if (this.privacyAttempts < 3) {
        this.privacyRetry = setTimeout(() => { if (this.isConnected) this.loadPrivacyApi(); }, this.privacyAttempts * 1000);
      }
    };
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) { finished(); return; }
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { finished(true); return; }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finished);
    } catch (error) { finished(error); }
  }

  noop() {
  }
}
customElements.define('cookie-banner', CookieBanner);
